import {
  GDDS_MARKER_COLOR_DEFAULT,
  GDDS_MARKER_COLORS,
  KOLO_MARKER_COLOR_DEFAULT,
  KOLO_MARKER_COLORS,
  XY_MARKER_COLOR_DEFAULT,
  XY_MARKER_COLORS,
} from './constants';

export const getMarkerColors = ({ isXy, isKolo }) => {
  if (isXy) {
    return XY_MARKER_COLORS;
  }
  if (isKolo) {
    return KOLO_MARKER_COLORS;
  }
  return GDDS_MARKER_COLORS;
};

export const getDefaultMarkerColor = ({ isXy, isKolo }) => {
  if (isXy) {
    return XY_MARKER_COLOR_DEFAULT;
  }
  if (isKolo) {
    return KOLO_MARKER_COLOR_DEFAULT;
  }
  return GDDS_MARKER_COLOR_DEFAULT;
};
